'use strict';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * @file env.js H5 环境判断
 * @module env
 * @date 2019-05-07
 */

/**
 * Env Class
 * @example:
 * // UserAgent info
 * // { "APP_DEVICE_KEY" : "402A3AB6-0F91-4549-B826-11AB131522E8", "JuvenileGet" : "1", "APP_TOKEN" :
 *   "21d9e39c-871a-4401-9fc2-4f66b6ab66bd", "APP_VERSION_NAME" : "1.5.1", "APP_USER" : "12303500001",
 *   "APP_DEVICE_TYPE" : "0", "APP_USER_PID" : "12014655", "AGENT_WEB_VIEW" : "igetios", "OS_INFO" : "iPhone11,6_12.2"}
 *
 * // 新版 UA 内容如下
 * Mozilla/5.0 (iPhone; CPU iPhone OS 12_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148
 *   AppVersion=2.9.0   JuvenileGet 其中追加了： AppVersion=2.9.0   JuvenileGet
 *
 * const env = new Env(navigator.userAgent)
 * env.isApp // true
 * env.appVer // 1.5.1
 */
var Env = /*#__PURE__*/function () {
  function Env() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

    _classCallCheck(this, Env);

    // Can not use RegExp global flag
    // App 在 2.8.0 以前(含)会在 UA 中注入以下字段
    var ANDROID_APP_REGEXP = /igetcool/i;
    var SENSORS = /igetcool\.com/i;
    var IOS_APP_REGEXP = /igetios/i; // App 在 2.8.0 以后仅会注入 JuvenileGet

    var APP_REGEXP = /JuvenileGet/i;
    this._isAndroidApp = ANDROID_APP_REGEXP.test(ua) && !SENSORS.test(ua);
    this._isIOSApp = IOS_APP_REGEXP.test(ua);
    this._isApp = APP_REGEXP.test(ua);
    this._isHuawei = ua.toLowerCase().indexOf('huawei') > -1 || ua.toLowerCase().indexOf('honor') > -1;
    this._isWeChat = false;
    this._isQQ = false;
    this._isWeibo = false;
    this._isMiniProgram = window.__wxjs_environment === 'miniprogram';
    var appVer = '';
    this._pid = '';
    this._devKey = '';
    this._devType = '';
    this._osVer = '';

    if (this.isApp) {
      // 老版本 UA 信息，匹配 {} 內的所有內容
      var oldAppRegExp = /{([^{}]*)}/;
      var matches = ua.match(oldAppRegExp);

      if (matches) {
        var confStr = matches[0];
        var confObj = JSON.parse(confStr);
        var _confObj$APP_VERSION_ = confObj.APP_VERSION_NAME,
            ver = _confObj$APP_VERSION_ === void 0 ? '' : _confObj$APP_VERSION_,
            _confObj$APP_USER_PID = confObj.APP_USER_PID,
            pid = _confObj$APP_USER_PID === void 0 ? '' : _confObj$APP_USER_PID,
            _confObj$APP_DEVICE_K = confObj.APP_DEVICE_KEY,
            devKey = _confObj$APP_DEVICE_K === void 0 ? '' : _confObj$APP_DEVICE_K;
        appVer = ver;
        this._pid = pid;
        this._devKey = devKey;
      } else {
        // 新版本 UA 信息，只有 AppVersion 和 JuvenileGet
        var newAppRegExp = /AppVersion=([\d.]+)/;

        var _matches = ua.match(newAppRegExp);

        if (_matches) {
          appVer = _matches[1];
        }
      }
    } else {
      var wx = ua.replace(/^.*MicroMessenger\/([\d.]+).*$/, '$1');
      var qq = ua.replace(/^.*QQ\/([\d.]+).*$/i, '$1');
      var isWX = /^.*MicroMessenger\/([\d.]+).*$/.test(ua);
      var isQQ = /^.*QQ\/([\d.]+).*$/i.test(ua);
      var isWeibo = ua.indexOf('weibo') !== -1;
      this._isWeibo = isWeibo;

      if (isWX) {
        this._isWeChat = true;
        appVer = wx;
      } else if (isQQ) {
        this._isQQ = true;
        appVer = qq;
      }
    }

    this._appVer = appVer; // 判断系统版本及版本号 this._osVer，对于老版 iOS app 无法判断正确版本号，因为 iOS 把原生 UA 覆盖掉了

    this._isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 || ua.indexOf('igetcool') > -1 && ua.indexOf('igetcool.com') === -1;
    this._isIOS = ua.indexOf('like Mac OS X') > -1 || ua.indexOf('igetios') > -1;

    if (this._isAndroid) {
      var adrVerRegExp = /^.*Android ([\d.]+);.*$/;

      var _matches2 = ua.match(adrVerRegExp);

      if (_matches2) {
        this._osVer = _matches2[1];
      }

      this._devType = 'Android';
    } else if (this._isIOS) {
      var iOSVerRegExp = /^.*OS ([\d_]+) like.*$/;

      var _matches3 = ua.match(iOSVerRegExp);

      if (_matches3) {
        this._osVer = _matches3[1].replace(/_/g, '.');
      }

      this._devType = 'IOS';
    } else ; // mobileDeviceType


    var deviceType = '';

    if (/ipad/i.test(ua)) {
      deviceType = 'iPad';
    } else if (/iphone|ipod/i.test(ua)) {
      deviceType = 'iPhone';
    } else if (/android/i.test(ua)) {
      deviceType = 'Android';
    } else {
      deviceType = '';
    }

    this._mobileDeviceType = deviceType;
    var browser = '';

    if (!this._isAndroidApp && !this._isIOSApp) {
      if (ua.indexOf('HUAWEI') > -1) {
        browser = 'HuaWeiDefault';
      } else if (ua.indexOf('HONOR') > -1) {
        browser = 'HONOR';
      } else if (ua.indexOf('UCBrowser') > -1) {
        browser = 'UC';
      } else if (ua.indexOf('Sogou') > -1) {
        // Sogou 浏览器 UA 包含，SogouMSE 和 SogouMobileBrowser. 暂时使用 Sogou 判断。
        browser = 'Sogou';
      } else if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
        browser = 'Safari';
      } else if (ua.indexOf('Firefox') > -1) {
        browser = 'FF';
      }

      this._browser = browser;
    }
  }

  _createClass(Env, [{
    key: "browser",
    get: function get() {
      return this._browser;
    }
    /**
     * 是否在少年得到 App 的 WebView 内
     * @returns {boolean}
     */

  }, {
    key: "isApp",
    get: function get() {
      return this._isAndroidApp || this._isIOSApp || this._isApp;
    }
  }, {
    key: "notInApp",
    get: function get() {
      return !this.isApp;
    }
  }, {
    key: "isIOSApp",
    get: function get() {
      return this._isIOSApp || this._isApp && this._isIOS;
    }
  }, {
    key: "isAndroidApp",
    get: function get() {
      return this._isAndroidApp || this._isApp && this._isAndroid;
    }
  }, {
    key: "isWeChat",
    get: function get() {
      return this._isWeChat;
    }
  }, {
    key: "isQQ",
    get: function get() {
      return this._isQQ;
    }
  }, {
    key: "isWeibo",
    get: function get() {
      return this._isWeibo;
    }
  }, {
    key: "isMiniProgram",
    get: function get() {
      return this._isMiniProgram;
    }
    /**
     * 获取所在软件的版本号
     * 例如：QQ 下获取 QQ 版本，微信下获取微信版本，App 下获取 App 的版本
     * 格式 '1.5.1'
     * @return {string}
     */

  }, {
    key: "appVer",
    get: function get() {
      return this._appVer;
    }
    /**
     * App 内的用户 pid，已废弃
     * @returns {string}
     */

  }, {
    key: "userPid",
    get: function get() {
      return this._pid;
    }
    /**
     * App 内设备 key，已废弃
     * @returns {string}
     */

  }, {
    key: "deviceKey",
    get: function get() {
      return this._devKey;
    }
    /**
     * 设备标识，App 内有效。已废弃
     * @deprecated
     * @returns {string}
     */

  }, {
    key: "deviceType",
    get: function get() {
      return this._devType;
    }
    /**
     * 安卓操作系统
     * @returns {boolean|*}
     */

  }, {
    key: "isAndroid",
    get: function get() {
      return this._isAndroid;
    }
    /**
     * iOS 操作系统
     * @returns {boolean|*}
     */

  }, {
    key: "isIOS",
    get: function get() {
      return this._isIOS;
    }
    /**
     * 华为 操作系统
     * @returns {boolean|*}
     */

  }, {
    key: "isHuawei",
    get: function get() {
      return this._isHuawei;
    }
    /**
     * 操作系统版本号
     * @returns {string}
     */

  }, {
    key: "OSVer",
    get: function get() {
      return this._osVer;
    }
  }, {
    key: "OSType",
    get: function get() {
      if (this._isAndroidApp || this._isAndroid) {
        return 'Android';
      } else if (this._isIOSApp || this._isIOS) {
        return 'IOS';
      } else {
        return '';
      }
    }
  }, {
    key: "environment",
    get: function get() {
      if (this.isApp) {
        return 'APP';
      } else if (this.isWeChat) {
        return 'WX';
      } else if (this.isQQ) {
        return 'QQ';
      } else {
        return '';
      }
    }
  }, {
    key: "mobileDeviceType",
    get: function get() {
      return this._mobileDeviceType;
    }
  }]);

  return Env;
}();
var env = new Env();

/**
 * Compare two semver
 * @param {string} a '1.2.3'
 * @param {string} b '1.2.3'
 * @returns {number} a > b => 1; a < b => -1; a = b => 0
 * @example
 * compareVersion('1.3.1', '1.3.7') = -1
 */

function compareVersion(a, b) {
  var pa = a.split('.');
  var pb = b.split('.');

  for (var i = 0; i < 3; i++) {
    var na = +pa[i];
    var nb = +pb[i];

    if (na > nb) {
      return 1;
    }

    if (nb > na) {
      return -1;
    }

    if (!isNaN(na) && isNaN(nb)) {
      return 1;
    }

    if (isNaN(na) && !isNaN(nb)) {
      return -1;
    }
  }

  return 0;
}

/**
 * @file Log
 * @author qiaogang
 * @date 2019-11-13
 */
var Log = {
  _options: {},
  config: function config() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this._options = _objectSpread2(_objectSpread2({}, {
      debug: false
    }), options);
  },
  _console: function _console(name) {
    if (this._options.debug) {
      var _console2;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      /* eslint-disable no-console */
      (_console2 = console)[name].apply(_console2, args);
    }
  },
  log: function log() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    this._console.apply(this, ['log'].concat(args));
  },
  warn: function warn() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    this._console.apply(this, ['warn'].concat(args));
  },
  error: function error() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    this._console.apply(this, ['error'].concat(args));
  }
};

var SUCCESS_MESSAGE = '成功';
var ERROR_MESSAGE = '失败';
var SUCCESS_CODE = 0;
var ERROR_CODE = -1;
var WX_MINI_APP_ORIGIN_ID = isH5ProdEnv() ? 'gh_3451c0ee7477' : 'gh_d8e232338b23';

window.IGC_Native2Js = function (data) {
  var params = JSON.parse(data);
  window[params.name] && window[params.name](params.params || {});
};

var postMessageToNative = function postMessageToNative(params) {
  return function () {
    if (env.isAndroidApp) {
      window.DDAppWebView.IGC_Js2Native(JSON.stringify(params));
    } else {
      window.webkit.messageHandlers.IGC_JS2Native.postMessage(params);
    }
  };
};

var MessageQueue = {};
var MessageQueueV2 = {};

if (!window.IGC_NativeCallBack) {
  window.IGC_NativeCallBack = {};
}

var ua = window.navigator.userAgent;

if (/JuvenileGet/i.test(ua)) {
  var newAppRegExp = /AppVersion=([\d.]+)/;
  var matches = ua.match(newAppRegExp);
  var appVer = '';

  if (matches) {
    appVer = matches[1];
  }

  if (appVer) {
    var v285 = compareVersion(appVer, '2.8.5');
    var v375 = compareVersion(appVer, '3.7.5');

    if (v285 >= 0 && v375 < 0) {
      window.IGC_JS2Native_V2 = function (args) {
        var _MessageQueue$args$na6, _MessageQueue$args$na7, _MessageQueue$args$na8;

        var channel = new MessageChannel();

        window.IGC_NativeCallBack[args.name] = function (nativeValue) {
          var _MessageQueue$args$na, _MessageQueue$args$na2, _MessageQueue$args$na3, _MessageQueue$args$na4, _MessageQueue$args$na5;

          if (MessageQueue !== null && MessageQueue !== void 0 && (_MessageQueue$args$na = MessageQueue[args.name]) !== null && _MessageQueue$args$na !== void 0 && (_MessageQueue$args$na2 = _MessageQueue$args$na.handle) !== null && _MessageQueue$args$na2 !== void 0 && _MessageQueue$args$na2[0]) {
            MessageQueue[args.name].handle[0].channel.port1.postMessage(nativeValue);
            MessageQueue[args.name].handle.splice(0, 1);
          } else {
            var _channel;

            (_channel = channel) === null || _channel === void 0 ? void 0 : _channel.port1.postMessage(nativeValue);
          }

          if (!(MessageQueue !== null && MessageQueue !== void 0 && (_MessageQueue$args$na3 = MessageQueue[args.name]) !== null && _MessageQueue$args$na3 !== void 0 && (_MessageQueue$args$na4 = _MessageQueue$args$na3.handle) !== null && _MessageQueue$args$na4 !== void 0 && _MessageQueue$args$na4.length) && typeof (MessageQueue === null || MessageQueue === void 0 ? void 0 : (_MessageQueue$args$na5 = MessageQueue[args.name]) === null || _MessageQueue$args$na5 === void 0 ? void 0 : _MessageQueue$args$na5.running) === 'boolean') {
            MessageQueue[args.name].running = false;
          }
        };

        var message = postMessageToNative(args);

        if (['doRequest', 'checkDeviceAuth', 'getUserInfo', 'wXPay'].includes(args.name)) {
          if (!MessageQueue[args.name]) {
            MessageQueue[args.name] = {
              handle: [],
              running: false
            };
          }

          MessageQueue[args.name].handle.push({
            channel: channel,
            message: message
          });
        } else {
          message();
        }

        if (MessageQueue !== null && MessageQueue !== void 0 && (_MessageQueue$args$na6 = MessageQueue[args.name]) !== null && _MessageQueue$args$na6 !== void 0 && (_MessageQueue$args$na7 = _MessageQueue$args$na6.handle) !== null && _MessageQueue$args$na7 !== void 0 && _MessageQueue$args$na7[0] && !(MessageQueue !== null && MessageQueue !== void 0 && (_MessageQueue$args$na8 = MessageQueue[args.name]) !== null && _MessageQueue$args$na8 !== void 0 && _MessageQueue$args$na8.running)) {
          MessageQueue[args.name].handle[0].message();
          MessageQueue[args.name].running = true;
        }

        return new Promise(function (resolve) {
          if (channel) {
            channel.port2.onmessage = function (e) {
              var _MessageQueue$args$na9, _MessageQueue$args$na10, _MessageQueue$args$na11;

              var data = e.data;
              MessageQueue === null || MessageQueue === void 0 ? void 0 : (_MessageQueue$args$na9 = MessageQueue[args.name]) === null || _MessageQueue$args$na9 === void 0 ? void 0 : (_MessageQueue$args$na10 = _MessageQueue$args$na9.handle) === null || _MessageQueue$args$na10 === void 0 ? void 0 : (_MessageQueue$args$na11 = _MessageQueue$args$na10[0]) === null || _MessageQueue$args$na11 === void 0 ? void 0 : _MessageQueue$args$na11.message();
              channel = null;
              resolve(data);
            };
          }
        });
      };
    } else if (v375 >= 0) {
      window.IGC_JS2Native_V2 = function (args) {
        var channel = new MessageChannel();
        var id = "".concat(args.name, "_").concat(Math.random());
        args.params = args.params || {};
        args.params.id = id;
        MessageQueueV2[id] = channel;

        window.IGC_NativeCallBack[args.name] = function (nativeValue) {
          var _nativeValue$params;

          var _id = nativeValue === null || nativeValue === void 0 ? void 0 : (_nativeValue$params = nativeValue.params) === null || _nativeValue$params === void 0 ? void 0 : _nativeValue$params.id;

          if (_id && MessageQueueV2[_id]) {
            MessageQueueV2[_id].port1.postMessage(nativeValue);

            delete MessageQueueV2[_id];
          } else {
            Log.error("\u56DE\u8C03\u51FD\u6570 ".concat(args.name, " \u9700\u8981\u8FD4\u56DE params"));
          }
        };

        postMessageToNative(args)();
        return new Promise(function (resolve) {
          if (channel) {
            channel.port2.onmessage = function (e) {
              var data = e.data;
              channel = null;
              resolve(data);
            };
          }
        });
      };
    }
  }
}

var initParams = {
  doGet: function doGet(params) {
    return [params.url, params.data];
  },
  doPost: function doPost(params) {
    return [params.url, params.data];
  },
  showToast: function showToast(params) {
    return [params.content];
  },
  setPageTitle: function setPageTitle(params) {
    return [params.title];
  },
  navigateTo: function navigateTo(params) {
    return [params.router, 'navigateToErr'];
  },
  showImagesBrowser: function showImagesBrowser(params) {
    params.images = params.images.map(function (item) {
      return {
        mImageUrl: item
      };
    });
    return [JSON.stringify(params)];
  },
  playMusic: function playMusic(params) {
    return [params.dataForApp, params.code];
  },
  pauseMusic: function pauseMusic() {
    return [];
  },
  mediaControl: function mediaControl(params) {
    if (params.method === 'play') {
      return [params.dataForApp, params.code];
    }

    return [];
  },
  notify: function notify(params) {
    return [params.name];
  },
  webShare: function webShare(params) {
    var channel = params.channel ? params.channel.join('-') : '';
    return [params.event, channel, 'web', JSON.stringify(params.shareInfo)];
  },
  doLogin: function doLogin(params) {
    return [params.type];
  }
};
var initResult = {
  checkMusicStateCallBack: function checkMusicStateCallBack(audioPid, isPlaying) {
    return {
      audioPid: audioPid,
      isPlaying: isPlaying
    };
  },
  doLogin: function doLogin(pid) {
    return {
      pid: pid
    };
  }
};

var NativeFunction = function NativeFunction(name) {
  var data = null;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (window.DDAppWebView && window.DDAppWebView[name]) {
    var _window$DDAppWebView;

    data = (_window$DDAppWebView = window.DDAppWebView)[name].apply(_window$DDAppWebView, args);
  } else if (window[name]) {
    var _window;

    data = (_window = window)[name].apply(_window, args);
  } else {
    data = null;
  }

  return data;
};

var random = function random(min, max) {
  var num = Math.floor(Math.random() * (min - max) + max);
  return num;
};

var stringToJson = function stringToJson(res) {
  var json = {};

  if (typeof res === 'string') {
    json = JSON.parse(res);
  } else {
    json = res;
  }

  return json;
};

var getAppUserPid = function getAppUserPid() {
  return new Promise(function (resolve) {
    if (!!window.IGC_JS2Native_V2) {
      JS2Native({
        name: 'getUserInfo'
      }).then(function (res) {
        if (res.code === 0) {
          if (Object.prototype.toString.call(res.data) === '[object Object]') {
            var json = res.data;
            var isLogin = json['isLogin'];
            var pid = json['App-User-Pid'];
            resolve({
              code: isLogin ? SUCCESS_CODE : ERROR_CODE,
              msg: isLogin ? SUCCESS_MESSAGE : ERROR_MESSAGE,
              data: isLogin ? pid : null
            });
          } else {
            resolve({
              code: ERROR_CODE,
              msg: ERROR_MESSAGE,
              data: null
            });
          }
        } else {
          resolve({
            code: ERROR_CODE,
            msg: ERROR_MESSAGE,
            data: null
          });
        }
      });
    } else {
      JS2Native({
        name: 'doRequest',
        params: {
          method: 'get',
          url: 'app-api-user-server/oath/user/info.json'
        }
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.code === 10000) {
          resolve({
            code: SUCCESS_CODE,
            msg: SUCCESS_MESSAGE,
            data: data.data.pid
          });
        } else {
          resolve({
            code: ERROR_CODE,
            msg: ERROR_MESSAGE,
            data: null
          });
        }
      }).catch(function () {
        resolve({
          code: ERROR_CODE,
          msg: ERROR_MESSAGE,
          data: null
        });
      });
    }
  });
};
var getLoginUrl = function getLoginUrl(type) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var arr = [];

  for (var key in data) {
    var value = data[key];
    arr.push("".concat(key, "=").concat(value));
  }

  var url = "igetcool://juvenile.dedao.passport/passport/v2/login?".concat(env.isAndroidApp ? 'params_type=20000&params_status=login_status' : 'isLastPage=0');

  if (type === 'window') {
    url = "igetcool://juvenile.dedao.passport/passport/quick/login?".concat(arr.join('&'));
  }

  return url;
};

var doDestroyAllAudio = function doDestroyAllAudio() {
  window.destroyAllAudio = function () {
    var audios = document.getElementsByTagName('audio');

    while (audios.length) {
      if (audios && audios[0] && audios[0].parentNode) {
        audios[0].parentNode.removeChild(audios[0]);
      }
    }
  };
};

var initParamsName = function initParamsName(params) {
  var name = params.name;

  if (name === 'doRequest') {
    var method = params.params.method;

    switch (method) {
      case 'get':
        name = 'doGet';
        break;

      case 'post':
        name = 'doPost';
        break;
    }
  } else if (name === 'mediaControl') {
    var _method = params.params.method;

    switch (_method) {
      case 'play':
        name = 'playMusic';
        break;

      case 'pause':
        name = 'pauseMusic';
        break;
    }
  } else if (name === 'getUserInfo') {
    name = 'onAuth';
  }

  return name;
};

var setDefaultParams = function setDefaultParams(_params) {
  var name = _params.name,
      _params$params = _params.params,
      params = _params$params === void 0 ? {} : _params$params;
  var defaultParams = {};

  switch (name) {
    case 'webShare':
      defaultParams = {
        event: 'sndd_app_traffic'
      };
      params.shareInfo = defaults(params.shareInfo, {
        hostAndPath: location.href
      });
      break;

    case 'screenShot':
      params.shareInfo = defaults(params.shareInfo, {
        hostAndPath: location.href
      });
      break;

    case 'goToMiniProgram':
      defaultParams = {
        appId: WX_MINI_APP_ORIGIN_ID
      };
      break;

    case 'setReferInfo':
      defaultParams = {
        refer_page_name: window.refer_page_name || '未知页面',
        refer_url: location.href
      };
      break;
  }

  _params.params = defaults(params, defaultParams);
  return _params;
};

var igetcool = {
  doRequest: function doRequest(name, url) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var code = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '0';
    return new Promise(function (resolve, reject) {
      var number = random(1, 10000);
      var date = +new Date();
      var successFunction = "successFunction_".concat(number).concat(date);
      var errorFunction = "errorFunction_".concat(number).concat(date);
      var data = {
        params: [],
        path: '',
        successFunction: '',
        errorFunction: ''
      };
      var array = [];

      if (Array.isArray(params)) {
        array = _toConsumableArray(params);
      } else {
        for (var key in params) {
          var value = params[key];
          array.push({
            key: key,
            value: value
          });
        }
      }

      data.params = array;
      data.path = url;
      data.successFunction = successFunction;
      data.errorFunction = errorFunction;

      window[successFunction] = function (res) {
        resolve({
          code: SUCCESS_CODE,
          data: stringToJson(res),
          msg: SUCCESS_MESSAGE
        });
        window[successFunction] = null;
      };

      window[errorFunction] = function (res) {
        reject({
          code: ERROR_CODE,
          data: stringToJson(res),
          msg: ERROR_MESSAGE
        });
        window[errorFunction] = null;
      };

      var arg = JSON.stringify(data);
      NativeFunction(name, arg, code);
    });
  },
  doLogin: function doLogin() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'page';
    return new Promise( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve) {
        var _yield$getAppUserPid, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getAppUserPid();

              case 2:
                _yield$getAppUserPid = _context2.sent;
                data = _yield$getAppUserPid.data;

                if (!data) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", resolve({
                  code: SUCCESS_CODE,
                  msg: SUCCESS_MESSAGE,
                  data: data
                }));

              case 6:
                JS2Native({
                  name: 'navigateTo',
                  params: {
                    router: getLoginUrl(type)
                  }
                }).then( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                    var _yield$getAppUserPid2, _data;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(res.code === 0)) {
                              _context.next = 6;
                              break;
                            }

                            _context.next = 3;
                            return getAppUserPid();

                          case 3:
                            _yield$getAppUserPid2 = _context.sent;
                            _data = _yield$getAppUserPid2.data;
                            resolve({
                              code: SUCCESS_CODE,
                              msg: SUCCESS_MESSAGE,
                              data: _data
                            });

                          case 6:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
  },
  navigateTo: function navigateTo(router) {
    return new Promise(function (resolve) {
      Native2Js({
        name: 'onPageResume'
      }, function () {
        resolve({
          code: SUCCESS_CODE,
          msg: SUCCESS_MESSAGE,
          data: null
        });
        window.navigateToErr = null;
      });
      doDestroyAllAudio();

      if (window.IGC_JS2Native_V2) {
        window.IGC_JS2Native_V2({
          name: 'navigateTo',
          params: {
            router: router
          }
        });
      } else {
        window.navigateToErr = function () {};

        NativeFunction('navigateTo', router, 'navigateToErr');
      }
    });
  },
  setReferInfo: function setReferInfo(params) {
    return new Promise(function (resolve) {
      if (window.IGC_JS2Native_V2) {
        window.IGC_JS2Native_V2({
          name: 'setReferInfo',
          params: params
        }).then(function (result) {
          resolve(result);
        });
      } else {
        resolve({
          code: ERROR_CODE,
          data: null,
          msg: ERROR_MESSAGE
        });
      }
    });
  },
  screenShot: function screenShot(params) {
    return new Promise(function (resolve) {
      if (window.IGC_JS2Native_V2) {
        setTimeout(function () {
          window.IGC_JS2Native_V2({
            name: 'screenShot',
            params: params
          }).then(function (result) {
            resolve(result);
          });
        }, 100);
      } else {
        resolve({
          code: ERROR_CODE,
          data: null,
          msg: ERROR_MESSAGE
        });
      }
    });
  }
};
var JS2Native = function JS2Native(params) {
  if (!env.isApp) return new Promise(function (resolve) {
    resolve({
      code: ERROR_CODE,
      data: null,
      msg: ERROR_MESSAGE
    });
  });
  params = setDefaultParams(params);

  if (params.name === 'doLogin') {
    var _params$params2;

    return igetcool.doLogin((_params$params2 = params.params) === null || _params$params2 === void 0 ? void 0 : _params$params2['type']);
  } else if (params.name === 'navigateTo') {
    var _params$params3;

    return igetcool.navigateTo((_params$params3 = params.params) === null || _params$params3 === void 0 ? void 0 : _params$params3['router']);
  } else if (params.name === 'getAppUserPid') {
    return getAppUserPid();
  } else if (params.name === 'screenShot') {
    return igetcool.screenShot(params.params);
  } else if (params.name === 'setReferInfo') {
    return igetcool.setReferInfo(params.params);
  }

  if (window.IGC_JS2Native_V2) {
    return window.IGC_JS2Native_V2(params);
  }

  var name = initParamsName(params);
  var arg = initParams[name] ? initParams[name](params.params) : [];

  if (name === 'doGet' || name === 'doPost') {
    return igetcool.doRequest(name, arg[0], arg[1]);
  } else {
    return new Promise(function (resolve) {
      var data = NativeFunction.apply(void 0, [name].concat(_toConsumableArray(arg)));

      if (name === 'onAuth') {
        data = stringToJson(data);
      }

      resolve({
        code: SUCCESS_CODE,
        data: data,
        msg: SUCCESS_MESSAGE
      });
    });
  }
};
var Native2JsCallBack = {};
var Native2Js = function Native2Js(params, callback) {
  params.params = params.params || {};
  var name = params.name;

  if (!Native2JsCallBack[name]) {
    Native2JsCallBack[name] = [];
  }

  Native2JsCallBack[name].push(callback);

  window[name] = function () {
    var json = {};

    if (Object.prototype.toString.call(arguments.length <= 0 ? undefined : arguments[0]) === '[object Object]') {
      json = arguments.length <= 0 ? undefined : arguments[0];
    } else {
      json = initResult[name] ? initResult[name].apply(initResult, arguments) : {};
    }

    Native2JsCallBack[name].forEach(function (_callback) {
      if (typeof _callback === 'function') {
        try {
          _callback(json);
        } catch (error) {}
      }
    });
  };
};

Native2Js.on = function (name, callback) {
  Native2Js({
    name: name
  }, callback);
};

Native2Js.off = function (name, callback) {
  if (!callback) {
    Native2JsCallBack[name] = [];
  } else if (Array.isArray(Native2JsCallBack[name]) && Native2JsCallBack[name].length && typeof callback === 'function') {
    Native2JsCallBack[name] = Native2JsCallBack[name].filter(function (_callback) {
      return _callback !== callback;
    });
  }
};

/**
 * 判断是否为 Nil（null/undefined）
 * @param {*} obj
 * @returns {boolean}
 */

function isNil(obj) {
  return obj == null;
}
function isFn(obj) {
  return typeof obj === 'function';
}
function isStr(obj) {
  return typeof obj === 'string';
}
/**
 * 设置默认属性
 * 目标对象中如果是 null 或 undefined，则会被默认配置覆盖。
 * 同时默认配置会过滤掉 null 和 undefined 的字段
 * @param {Object} obj 目标对象
 * @param {Object} defObj 默认配置
 * @returns {Object}
 */

function defaults(obj, defObj) {
  var mergeObj = _objectSpread2({}, obj);

  for (var key in defObj) {
    if (defObj.hasOwnProperty(key)) {
      var value = defObj[key];

      if (!isNil(value) && isNil(mergeObj[key])) {
        mergeObj[key] = value;
      }
    }
  }

  return mergeObj;
}
/**
 * 显示元素的 CSS Path
 * @param {HTMLElement} el
 * @returns {string|undefined}
 */

function cssPath(el) {
  if (!(el instanceof Element)) {
    return;
  }

  var path = [];

  while (el.nodeType === Node.ELEMENT_NODE) {
    var selector = el.nodeName.toLowerCase();

    if (el.id) {
      selector += '#' + el.id;
    } else {
      var sib = el,
          nth = 1;

      while (sib.nodeType === Node.ELEMENT_NODE && (sib = sib.previousSibling)) {
        nth++;
      }

      selector += ':nth-child(' + nth + ')';
    }

    path.unshift(selector);
    el = el.parentNode;
  }

  return path.join(' > ');
}
/**
 * 查找指定元素，如无则一直向父级查找，直至根节点
 * @param {HTMLElement} el 起始元素
 * @param {Function} fn 查询函数，返回 true 则表示命中
 * @returns {HTMLElement|null}
 */

function findParentEl(el, fn) {
  var findEl;
  var curEl = el;

  while (curEl && curEl.tagName !== 'HTML' && curEl.nodeType === Node.ELEMENT_NODE) {
    if (fn(curEl)) {
      findEl = curEl;
      break;
    } else {
      curEl = curEl.parentNode;
    }
  }

  return findEl;
}
/**
 * 查找 trackName 事件名称
 * @param {Object} config 发送 LogTrack 时携带的 value
 * @returns {string|null}
 */

function findTrackName(config) {
  var trackName = undefined;

  if (config !== undefined) {
    if ('__ev_track_name' in config) {
      trackName = config.__ev_track_name;
    }
  }

  return trackName;
}
/**
 * 获取用户和设备的信息
 * @returns {Object} 用户的 did 和 pid 的对象
 */

function getUserInfo() {
  var d = {
    appChannel: '',
    appDeviceKey: '',
    appDeviceType: '',
    appToken: '',
    appUserPid: '',
    appUserAppAgent: '',
    appVersion: '',
    isLogin: false
  };
  var p = new Promise(function (resolve) {
    if (env.isApp) {
      JS2Native({
        name: 'getUserInfo'
      }).then(function (res) {
        if (res.code === 0) {
          if (Object.prototype.toString.call(res.data) === '[object Object]') {
            var json = res.data;
            var appChannel = json['App-Channel'];
            var appDeviceKey = json['App-Device-Key'];
            var appDeviceType = json['App-Device-Type'];
            var appToken = json['App-Token'];
            var appUserPid = json['App-User-Pid'];
            var appUserAppAgent = json['App-UserApp-Agent'];
            var appVersion = json['App-Version'];
            var isLogin = json['isLogin'];
            resolve({
              appChannel: appChannel,
              appDeviceKey: appDeviceKey,
              appDeviceType: appDeviceType,
              appToken: appToken,
              appUserPid: appUserPid,
              appUserAppAgent: appUserAppAgent,
              appVersion: appVersion,
              isLogin: isLogin
            });
          } else {
            resolve(d);
          }
        } else {
          resolve(d);
        }
      });
    } else {
      var userInfo = JSON.parse(localStorage.getItem('IGetCool-USER-Info')) || {};
      d.appUserPid = userInfo.uid ? userInfo.uid : '';
      resolve(d);
    }
  });
  return p;
}
/**
 * 根据域名区分H5生产还是正式环境，简单版，精确版使用下面的 isProdEnv
 */

function isH5ProdEnv() {
  // 简单粗暴的判断了域名
  return location.hostname === 'igetcool-share.igetcool.com';
}
/**
 * 根据域名区分生产还是正式环境
 */

function isProdEnv() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.hostname;
  var regExp = /^(.*)\.igetcool\.com$/i;
  var matches = hostname.match(regExp);

  if (matches) {
    var subHost = matches[1] || '';
    var devRegExp = /(sim|test|dev|local)/i;
    return !devRegExp.test(subHost);
  }

  return false;
}
function isHttpProtocol(url) {
  var httpReg = /^(http|https):\/\//ig;
  return httpReg.test(url);
}
function isAppProtocol(url) {
  var reg = /^igetcool:\/\//ig;
  return reg.test(url);
}
function isCustomizeSchema(url) {
  var reg = /^[\w\.]+:\/\//i;
  return reg.test(url);
}
function http2AppLink(url) {
  if (isHttpProtocol(url)) {
    return "igetcool://juvenile.dedao.app/go/h5?params_url=".concat(encodeURIComponent(url));
  }

  return url;
}
/**
 * 从 go/h5 中解析跳转地址，如果解析不出地址，返回原地址
 * @param {string} url
 * @returns {string}
 */

function appLink2Http(url) {
  if (isAppProtocol(url)) {
    var reg = /^igetcool:\/\/juvenile\.dedao\.app\/go\/h5(.*)$/i;
    var matches = url.match(reg);

    if (matches && matches[1]) {
      var urlSearch = new URLSearchParams(matches[1]);
      var paramsUrl = urlSearch.get('params_url');

      if (paramsUrl) {
        return paramsUrl;
      }
    }
  }

  return url;
}
/**
 * 判断是否为 go/h5 的链接
 * @param {string} url
 * @returns {boolean}
 */

function isAppGoH5Link(url) {
  var reg = /^igetcool:\/\/juvenile\.dedao\.app\/go\/h5(.*)$/i;
  var matches = url.match(reg);
  return !!matches;
}

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isNil: isNil,
  isFn: isFn,
  isStr: isStr,
  defaults: defaults,
  cssPath: cssPath,
  findParentEl: findParentEl,
  findTrackName: findTrackName,
  getUserInfo: getUserInfo,
  isH5ProdEnv: isH5ProdEnv,
  isProdEnv: isProdEnv,
  isHttpProtocol: isHttpProtocol,
  isAppProtocol: isAppProtocol,
  isCustomizeSchema: isCustomizeSchema,
  http2AppLink: http2AppLink,
  appLink2Http: appLink2Http,
  isAppGoH5Link: isAppGoH5Link
});

var index = {
  utils: utils,
  env: env
};

module.exports = index;
//# sourceMappingURL=index.cjs.js.map
